exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fun-facts-m{border-radius:10%;color:#fff;display:table;height:50%;margin:0 auto;text-align:center;width:50%;background:#c91b1b}.fun-facts-m h2{color:#fff;margin:0 auto;font-size:30px}.fun-facts-m p{font-size:12px;line-height:22px;margin:0 auto}img.logo-inps.float-right{width:50%}.listing_detail_wrap .nav-tabs>li a.active{color:#fff;background:#000!important}.listing_detail_wrap .tab-content{padding:0}", ""]);

// exports
